import React from "react";

const StatCard = ({ icon, label, value }) => {
  return (
    <div style={{
      backgroundColor: "#fff",
      padding: "clamp(16px, 3vw, 24px)",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      display: "flex",
      gap: "clamp(12px, 2vw, 16px)",
      alignItems: "center",
      justifyContent: "flex-start",
      minWidth: "0",
      flexWrap: "wrap",
    }}>
      <div style={{
        width: "clamp(48px, 8vw, 58px)",
        height: "clamp(48px, 8vw, 58px)",
        backgroundColor: "#F5F6FE",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #12188A",
        flexShrink: 0
      }}>
        {icon}
      </div>
      <div style={{
        minWidth: "0",
        flex: "1"
      }}>
        <div style={{ 
          fontSize: "clamp(14px, 2.5vw, 18px)", 
          color: "#171A56",
          marginBottom: "4px",
          fontStyle: "normal",
          fontWeight: "500",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}>
          {label}
        </div>
        <div style={{ 
          fontSize: "clamp(18px, 3vw, 24px)", 
          fontWeight: "700", 
          color: "#171A56",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}>
          {value}
        </div>
      </div>
    </div>
  );
};

export default StatCard;